<template>
  <div class="base-slider">
    <h3 class="base-slider__title">
      {{ title }}
    </h3>
    <vue-slider
      ref="slider"
      v-model="proxyValue"
      v-bind="options"
      @drag-end="handleDragEnd"></vue-slider>
    <div class="base-slider__value-container">
      <input
        ref="minInput"
        class="base-slider__input"
        type="number"
        :min="min"
        :max="max"
        :value="proxyValue[0]"
        @blur="event => handleMinInput(+event.target.value)">
      <input
        ref="maxInput"
        class="base-slider__input"
        type="number"
        :min="min"
        :max="max"
        :value="proxyValue[1]"
        @blur="event => handleMaxInput(+event.target.value)">
    </div>
  </div>
</template>

<script>
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/antd.css'
import _ from 'lodash'

export default {
  components: {
    VueSlider
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    min: {
      type: Number,
      required: true
    },
    max: {
      type: Number,
      required: true
    },
    selectedValues: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      proxyValue: [0, 0]
    }
  },
  computed: {
    options() {
      const defaultOptions = {
        dotSize: 15,
        height: 8,
        min: this.min,
        max: this.max,
        silent: true,
        contained: true,
        disabled: false,
        lazy: true,
        enableCross: false,
        dotStyle: {
          backgroundColor: '#006DB6',
          border: 'none'
        },
        railStyle: {
          backgroundColor: '#DFEBF3'
        },
        processStyle: {
          backgroundColor: '#DFEBF3'
        }
      }

      return _.merge(defaultOptions, this.$attrs)
    },
    currentMinMax() {
      return [this.min, this.max]
    },
    selectedMin() {
      return this.proxyValue[0]
    },
    selectedMax() {
      return this.proxyValue[1]
    }
  },
  watch: {
    selectedValues(newVal) {
      if(_.isEmpty(newVal)) {
        this.$refs.slider.setValue([this.min, this.max])
      }
    },
    currentMinMax(newVal, oldVal) {
      const isMinUntouched = this.selectedMin === oldVal[0]
      const isMinTooSmall = this.selectedMin < newVal[0]

      const isMaxUntouched = this.selectedMax === oldVal[1]
      const isMaxTooBig = this.selectedMax > newVal[1]

      const newMin = isMinUntouched || isMinTooSmall ? newVal[0] : this.selectedMin
      const newMax = isMaxUntouched || isMaxTooBig ? newVal[1] : this.selectedMax

      if(!_.isEqual(this.proxyValue, [newMin, newMax])) {
        this.$refs.slider.setValue([newMin, newMax])
      }
    }
  },
  mounted() {
    this.$refs.slider.setValue([this.min, this.max])
  },
  methods: {
    handleDragEnd() {
      this.$emit('input', this.proxyValue)
    },
    handleMinInput(value) {
      const noChange = value === this.proxyValue[0]
      if(noChange) return

      if(value >= this.min && value < this.selectedMax) {
        this.$refs.slider.setValue([value, this.selectedMax])
        this.$emit('input', this.proxyValue)
      } else {
        this.$refs.minInput.value = this.selectedMin
      }
    },
    handleMaxInput(value) {
      const noChange = value === this.proxyValue[1]
      if(noChange) return

      if(value <= this.max && value > this.selectedMin) {
        this.$refs.slider.setValue([this.selectedMin, value])
        this.$emit('input', this.proxyValue)
      } else {
        this.$refs.maxInput.value = this.selectedMax
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.base-slider {
  background-color: white;
  width: auto;
}

.base-slider__title {
  @include body-smaller-bold;
}

.base-slider__value-container {
  display: flex;
  justify-content: space-between;
  margin: 2rem 0;
}

.base-slider__input {
  border: 1px solid color(gray-4);
  width: 6rem;
  height: 2.5rem;
  padding: measure(quarter);

}

/* Hide number controls Chrome, Safari, Edge, Opera */
.base-slider__input::-webkit-outer-spin-button,
.base-slider__input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Hide number controls Firefox */
.base-slider__input {
  -moz-appearance: textfield;
}

.base-slider__value-cell > span {
  padding: 0 0.5rem;
}
</style>
